import api from './api';

const detail = (e: any, fallback: string) =>
  e?.response?.data?.detail || e?.message || fallback;

export const sendPasswordOtp = async (email: string) => {
  try {
    const res = await api.post('/auth/forgot-password', { email });
    return res.data;
  } catch (e: any) {
    throw new Error(detail(e, 'Could not send verification code'));
  }
};

export const verifyOtp = async (email: string, otp: string) => {
  try {
    const res = await api.post('/auth/verify-otp', { email, otp });
    return res.data;
  } catch (e: any) {
    throw new Error(detail(e, 'Invalid or expired code'));
  }
};

// Signed-in change from Profile > Security: the bearer token identifies the
// account, so only the current password is needed — no emailed OTP.
export const updatePassword = async (currentPassword: string, newPassword: string) => {
  try {
    const res = await api.post('/auth/update-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return res.data;
  } catch (e: any) {
    throw new Error(detail(e, 'Could not update password'));
  }
};

export const changePassword = async (email: string, otp: string, newPassword: string) => {
  try {
    const res = await api.post('/auth/change-password', {
      email, otp, new_password: newPassword,
    });
    return res.data;
  } catch (e: any) {
    throw new Error(detail(e, 'Could not update password'));
  }
};
